import React from 'react';
import AskQuestion from './AskQuestion';

const AskAIPage = () => {
  return <AskQuestion />;
};

export default AskAIPage;